/* ============================================================
   Kanadeal — Place le carrousel de bannieres de categorie (bento) JUSTE
   AU-DESSUS de la section FAQ sur la page d'accueil (comme sur les pages
   collection). Deplacement DOM only (aucune duplication), idempotent + retry.
   NB 04/07/2026 : selecteur generique [class*="bento-box--items-"]
   (items-4 -> items-5 avec Vape CBD).
   ============================================================ */
(function () {
  function run() {
    var main = document.querySelector('main[data-template="index"]');
    if (!main) return true; // pas l'accueil

    var track = main.querySelector('.bento-box[class*="bento-box--items-"]');
    if (!track) return false;
    var bentoSection = track.closest('.shopify-section');
    if (!bentoSection) return false;

    // Trouver la section FAQ = une .shopify-section contenant un accordeon
    var faqSection = null;
    var secs = main.querySelectorAll('.shopify-section');
    for (var i = 0; i < secs.length; i++) {
      if (secs[i] === bentoSection) continue;
      if (secs[i].querySelector('.accordion, accordion-custom, details.accordion, [class*="accordion"]')) {
        faqSection = secs[i];
        break;
      }
    }
    if (!faqSection) return false;

    if (bentoSection.nextElementSibling === faqSection) return true; // deja juste au-dessus
    faqSection.parentNode.insertBefore(bentoSection, faqSection);
    return true;
  }

  function init() {
    if (run()) return;
    var n = 0;
    var iv = setInterval(function () {
      n++;
      if (run() || n > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', init);
})();
